module.exports = __webpack_public_path__ + "static/media/playV2.c5d22331.svg";